import { Modal, message, Space } from 'antd';
import React from 'react';
import DishSelectionSearch from './components/DishSelectionSearch';
import DishSelectionTable from './components/DishSelectionTable';
import { useDishSelection } from './hooks/useDishSelection';

interface DishSelectionModalProps {
    visible: boolean;
    onCancel: () => void;
    onSelect: (dishIds: string[]) => void;
    onAddSingle?: (dishId: string) => Promise<void>;
    excludeDishIds?: string[];
}

const DishSelectionModal: React.FC<DishSelectionModalProps> = ({
    visible,
    onCancel,
    onSelect,
    onAddSingle,
    excludeDishIds = [],
}) => {
    const {
        loading,
        dishes,
        selectedRowKeys,
        addingDishIds,
        pagination,
        searchText,
        setSelectedRowKeys,
        setSearchText,
        handleSearch,
        handleTableChange,
        handleAddSingle,
    } = useDishSelection({
        visible,
        excludeDishIds,
    });

    const handleOk = () => {
        if (selectedRowKeys.length === 0) {
            message.warning('Vui lòng chọn ít nhất một món ăn');
            return;
        }
        onSelect(selectedRowKeys as string[]);
    };

    const handleCancel = () => {
        setSelectedRowKeys([]);
        setSearchText('');
        onCancel();
    };

    const handleAddSingleDish = async (dishId: string) => {
        await handleAddSingle(dishId, onAddSingle);
    };

    return (
        <Modal
            title="Chọn món ăn để thêm vào bộ sưu tập"
            open={visible}
            onCancel={handleCancel}
            onOk={handleOk}
            width={1000}
            okText={`Thêm ${selectedRowKeys.length} món ăn`}
            cancelText="Hủy"
        >
            <DishSelectionSearch
                value={searchText}
                onSearch={handleSearch}
                onChange={setSearchText}
            />

            <DishSelectionTable
                dishes={dishes}
                loading={loading}
                selectedRowKeys={selectedRowKeys}
                addingDishIds={addingDishIds}
                excludeDishIds={excludeDishIds}
                pagination={pagination}
                onSelectionChange={setSelectedRowKeys}
                onTableChange={handleTableChange}
                onAddSingle={handleAddSingleDish}
            />
        </Modal>
    );
};

export default DishSelectionModal;

